import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getMinutes/index.js';

var require$$19 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$19 as default };
